<template>
	<div class="wrap">
		<Title :title="vacationName"></Title>
		<div class="export-wrap">
			<el-button type="primary" size="mini" @click="addTask">添加</el-button>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column prop="taskName" label="任务名称">
			</el-table-column>
			<el-table-column prop="taskContent" label="任务内容" width="480">
				<template slot-scope="scope">
					<div class="message-content" v-html="scope.row.taskContent"></div>
				</template>
			</el-table-column>
			<el-table-column prop="coverFileUrl" label="任务图片">
				<template slot-scope="scope">
					<img v-if="scope.row.coverFileUrl" style="width:100px; height: 100px;" :src="scope.row.coverFileUrl"/>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="activityType" label="活动类型">
				<template slot-scope="scope">
					<span v-if="scope.row.activityType==0">包裹发放</span>
					<span v-if="scope.row.activityType==1">最美推荐</span>
				</template>
			</el-table-column> -->
			<el-table-column label="操作" width="120">
				<template slot-scope="scope">
					<div class="manage-btns">
						<span @click="addTask(scope.row)">修改</span>
						<span class="space"> | </span>
						<span @click="deleteTask(scope.row)">删除</span>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- <div class="export-wrap">
			<el-button type="primary" size="mini">批量删除</el-button>
		</div> -->
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		<!--视频预览-->
		<el-dialog title="添加任务" :visible.sync="detailDialog" width="50%" @close="handleClose()">
			<el-form :inline="true" :model="formInfo" :rules="rules" ref="messageForm" class="add-dialog">
				<el-form-item label="任务名称" prop="taskName">
					<el-input v-model="formInfo.taskName" placeholder="请填写活动主题名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="任务内容" prop="taskContent">
					<div class="editor-wrap">
						<quill-editor class="editor" v-model="formInfo.taskContent" ref="myQuillEditor" :options="editorOption"/>
					</div>
					<!-- <el-input :rows="6" type="textarea" clearable placeholder="请输入任务内容"
						v-model="formInfo.taskContent"></el-input> -->
				</el-form-item>
				<el-form-item label="任务图片" prop="coverFileUrl">
					<el-upload
					:action= uploadUrl
					  list-type="picture-card"
					  accept=".jpg,.jpeg,.png,.gif"
					  :limit="1"
					  :file-list="imgList"
					  :before-upload="beforeUpload"
					  :on-success="handleSuccessLogo"
					  :on-preview="handlePreviewLogo"
					  :on-remove="handleRemoveLogo">
					  <i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
					<div class="upload-tips">*图片尺寸建议750*400，或等比例尺寸</div>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="toRset">重置</el-button>
						<el-button size="mini" type="primary" @click="toConfirm">提交</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post, ajaxParam, config } from '@/units/request.js'
	import { quillEditor } from "vue-quill-editor"; //调用编辑器
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import { Quill } from "vue-quill-editor"; 
	import { eeSourceBtn } from '@/units/quill.eeSourceBtn.js';
	// 注册我们写的事件
	Quill.register( 'modules/eeSourceBtn', eeSourceBtn );
	export default {
		name: 'MessageList',
		components: {
			Title,
			quillEditor,
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				vacationId: '',
				vacationName: '',
				activityType: '0', //活动类型(0包裹发放,1最美推荐)
				detailDialog: false,
				dialogVisible: false,
				dialogImageUrl: '',
				imgList: [],
				editorOption: {
					placeholder: "请在这里输入",
					modules: {
						eeSourceBtn: eeSourceBtn,  // 引入我我们新增的事件
						toolbar: {
							container: [
								['bold', 'strike'],    //加粗，斜体，下划线，删除线
								[{ 'script': 'sub' }, { 'script': 'super' }],   // 上下标
							]
						}
					}
				},
				formInfo: {
					taskId: '',
					taskName: '', 
					taskContent: '',
					coverFileUrl: ''
				},
				rules: {
					taskName: [{
						required: true,
						message: '请填写活动主题名称',
						trigger: 'blur'
					}],
					taskContent: [{
						required: true,
						message: '请输入任务内容',
						trigger: 'blur'
					}]
				}
			}
		},
		created(){
			this.uploadUrl = config.baseUrl + 'admin/sys/upload'
			this.vacationId = this.$route.query.id||''
			this.getDataList()
		},
		methods: {
			//获取消息列表
			async getDataList() {
				let param = {
					vacationId: this.vacationId,
					// activityType: this.activityType,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/task/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.dataList = res.data.page.items
					this.total = res.data.page.count
					this.vacationName = res.data.vacationName
					this.vacationId = res.data.vacationId
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			//发布状态改变
			changePublic(row){
				let status = row.status?'取消发布':'发布'
				this.$confirm('确定要'+status+'吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id,
						status: row.status?'0':'1'
					}
					ajaxParam(param)
					const res = await post('admin/notice/updateStatus', qs.stringify(param))
					if (res.data.code == 200) {
						console.log(res.data)
						this.dataList.forEach(item=>{
							if(item.id==row.id){
								item.status = item.status?false:true
							}
						})
					}
				}).catch(() => {
				
				})
			},
			//删除消息
			deleteTask(row){
				this.$confirm('确定要删除消息吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id
					}
					ajaxParam(param)
					const res = await post('admin/task/delete', qs.stringify(param))
					if (res.data.code == 200) {
						this.$message.success('删除成功！')
						this.dataList.forEach((item,index)=>{
							if(item.id==row.id){
								this.dataList.splice(index,1)
							}
						})
					}
				}).catch(() => {
							
				})
			},
			//添加消息
			addTask(row){
				this.detailDialog = true
				console.log('--------')
				console.log(row)
				//问题：这里row传过来的status竟然是true,转换了一下
				if(row.id){
					this.formInfo.taskId = row.id
					this.formInfo.taskName = row.taskName
					this.formInfo.taskContent = row.taskContent
					this.formInfo.coverFileUrl = row.coverFileUrl ||''
					if(this.formInfo.coverFileUrl){
						this.imgList.push({
							url:  row.coverFileUrl
						})
					}
				}
			},
			//提交
			toConfirm(){
				this.$refs.messageForm.validate( async valid =>{
					if(valid){
						if(this.formInfo.taskContent.length>500){
							this.$message.error('您输入内容过多，不能超过400字！')
							return
						}
						let param = {
							id: this.formInfo.taskId||'',
							activityType: this.activityType,
							vacationId: this.vacationId,
							taskName: this.formInfo.taskName,
							taskContent: this.formInfo.taskContent,
							coverFileUrl: this.formInfo.coverFileUrl
						}
						ajaxParam(param)
						const res = await post('admin/task/saveOrUpdate', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('提交成功！')
							this.detailDialog = false
							this.getDataList()
						}
					}
				})
			},
			//关闭消息详情弹框
			handleClose(){
				this.detailDialog = false
				this.formInfo.taskId = ''
				this.formInfo.taskName = ''
				this.formInfo.taskContent = ''
				this.formInfo.coverFileUrl = ''
				this.dialogImageUrl = ''
				this.imgList = []
			},
			//重置详情弹窗
			toRset(){
				this.formInfo.taskName = ''
				this.formInfo.taskContent = ''
			},
			//上传图片相关
			handleRemoveLogo(file) {
				console.log(file);
			},
			handleSuccessLogo(res){
				let entity = res.entity
				this.formInfo.coverFileUrl = entity.fileUrl
			},
			handlePreviewLogo(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			beforeUpload(file){
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['jpg', 'jpeg', 'png', 'gif']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("只能上传jpg,jpeg,png,gif格式图片！")
					return false
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}
	.message-content{
		//height: 26px;
		// overflow: hidden;
		// text-overflow: ellipsis;
		// white-space: nowrap
	}
	.export-wrap{
		display: flex;
		padding: 10px 0 15px;
	}
	.flex-end{
		display: flex;
		justify-content: flex-end;
		
	}
	.manage-btns{
		color: #EB6B1B;
		span{
			cursor: pointer;
		}
		.space{
			margin: 0 5px;
			cursor: default;
		}
	}
	.upload-tips{
		color: #EB1B1B;
		font-size: 12px;
	}
	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}
	
	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 15px;
	}
	
	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-switch.is-disabled {
	 opacity: 1;
	}
	/deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
	  cursor: pointer !important;;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		padding-top: 10px;
	}
	.el-dialog__wrapper /deep/ .el-form--inline .el-form-item{
		width: 100%;
		display: flex;
	}
	.el-dialog__wrapper /deep/ .el-form-item__content{
		flex: 1
	}
	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card{
		width: 120px;
		height: 120px;
		line-height: 120px;
	}
	.editor-wrap {
		margin-bottom: 60px;
		.editor{
			height: 150px;
		}
	}
	/deep/ .ql-snow.ql-toolbar button{
		width: auto
	}
	/deep/ .ql-toolbar.ql-snow{
		padding: 0 8px;
	}
</style>